import React, { useState } from 'react'
import Table from 'UI/Table'
import { columns, subTableColumns } from './Columns'

const IPAssetExternalTable = ({ hostsData }) => (
  <Table
    columns={columns}
    data={hostsData}
    filterable
    SubComponent={(row) => <Table filterable columns={subTableColumns} data={row.original.assets} />}
  />
)

export default IPAssetExternalTable